import { React, _n } from 'pexui';

const AccountVerificationModal = ({
  usableIdentifiers,
  failedIdentifiers,
  handleSubmit,
  handleDecline,
}) => (
  <div id="account-confirmation-modal" className="infw-modal-wrapper px-widget">
    <div
      id="modal-container"
      className="infw-dialog-frame dls-accent-white-01-bg container-fluid text-align-center"
    >
      <div className="infw-font-bold title">
        {_n('yodlee.acm.header_1')}
      </div>
      {usableIdentifiers.map(identifier => (
        <div className="row success">
          <span
            className="dls-icon-success icon-sm dls-rewards-green-02 icon"
          />
          {`ACCOUNT NO X-${identifier.account_number_ending_4_digits}`}
        </div>
      ))}
      <div className="title">
        {_n('yodlee.acm.header_2')}
      </div>
      {failedIdentifiers.map((identifier) => {
        const errorMessageBody = identifier.bank_name ? identifier.bank_name : `ACCOUNT NO X-${identifier.account_number_ending_4_digits}`;
        return (
          <div className="row fail">
            <span
              arialabel="warning icon"
              role="alert"
              className="dls-icon-warning-filled dls-icon-warning-filled dls-accent-red-01 icon"
            />
            {errorMessageBody}
          </div>
        );
      })}
      <div>
        <button
          className="btn btn-primary btn-fluid"
          onClick={handleSubmit}
        >
          {_n('yodlee.acm.btn.submit')}
        </button>
      </div>
      <div>
        <button
          className="btn btn-secondary btn-fluid decline"
          onClick={handleDecline}
        >
          {_n('yodlee.acm.btn.decline')}
        </button>
      </div>
    </div>
  </div>
);

export default AccountVerificationModal;



// WEBPACK FOOTER //
// ./application/src/views/yodlee/accountVerificationModal.jsx